import { Klass, u_ } from "@pressmedia/webappbase";
import "./klass.VuwReplicant";

export default {
	/**
	 * VuwReplicantの追加関数
	 * @param {Integer} [length]
	 * @param {Object} [opt]
	 * @returns Promise
	 */
	async addReplicants(length, opt) {
		const replicantsLength = this.getReplicants().length;
		const promiseList = [];
		const callback = function callback() {
			this.container.isReady && promiseList.push( this.getReady() );
		};
		
		u_.isNumber(length) || (length = 1);
		u_.isObject(opt) || (opt = {});
		opt.vuwType = "replicant";
		
		for(let i = 0; i < length; i++) {
			this.add(`replicant_${String(replicantsLength + i)}`, opt, callback);
		}
		
		return !!promiseList.length && Promise.all(promiseList);
	},
	
	/**
	 * 引数で渡されたvuwがreplicantかどうかのチェック
	 * @param {instance of Vuw} vuw
	 * @returns Boolean
	 */
	_voightKampffCheck(vuw) {
		return vuw instanceof Klass("VuwReplicant");
	},
	
	/**
	 * 内包するVuwReplicantの取得関数
	 * @returns Array
	 */
	getReplicants() {
		const replicants = [];
		this.getChildren().forEach(vuw => {
			this._voightKampffCheck(vuw) && replicants.push(vuw);
		});
		return replicants;
	},
	
	/**
	 * 内包するVuwReplicantの削除関数
	 * @returns this
	 */
	removeReplicants() {
		this.getChildren().forEach(vuw => {
			this._voightKampffCheck(vuw) && this.remove(vuw.name);
		});
		return this;
	},
	
	/**
	 * 内包するVuwReplicantのstate.isを"rendering"に変更する関数
	 * @param {Function} [callback]
	 * @returns Promise
	 */
	async _startRenderingReplicants(callback) {
		const replicants = this.getReplicants();
		
		if(replicants.length) {
			try {
				const res = await Promise.all(
					replicants.map(vuw => vuw.setState("is", "rendering"))
				);
				
				return !u_.isFunction(callback) || callback(null, res);
				
			} catch(e) {
				return u_.isFunction(callback) && callback({
					code: NaN,
					messages: [e],
					method: "_startReplicantsRendering"
				});
			}
			
		} else {
			return !u_.isFunction(callback) || callback(null);
		}
	},
	
	/**
	 * 内包するVuwReplicantのstate.isを"sleeping"に変更する関数
	 * @param {Function} [callback]
	 * @returns Promise
	 */
	async putAllReplicantsToSleep(callback) {
		const replicants = this.getReplicants();
		
		if(replicants.length) {
			try {
				const res = await Promise.all(
					replicants.map(vuw => vuw.setState("is", "sleeping"))
				);
				
				return !u_.isFunction(callback) || callback(null, res);
				
			} catch(e) {
				return u_.isFunction(callback) && callback({
					code: NaN,
					messages: [e],
					method: "putAllReplicantsToSleep"
				});
			}
			
		} else {
			return !u_.isFunction(callback) || callback(null);
		}
	}
};
